export function substituteUserInPath(path: string, username: string | undefined): string {
  if (!username) return path;
  return path.replace(/\{\{USER\}\}/g, username);
}

export interface GetJupyterUrlOptions {
  notebook?: string;
  cellId?: string;
}

export function getJupyterUrl(
  baseUrl: string,
  workspaceDir: string,
  notebookOrOptions?: string | GetJupyterUrlOptions,
  cellId?: string
): string {
  let options: GetJupyterUrlOptions;
  if (typeof notebookOrOptions === 'string') {
    options = { notebook: notebookOrOptions, cellId };
  } else {
    options = notebookOrOptions ?? {};
  }

  const { notebook, cellId: optCellId } = options;
  const finalCellId = cellId ?? optCellId;

  const url = new URL(baseUrl);

  url.pathname = notebook ? `/doc/tree/${workspaceDir}/${notebook}` : `/lab/tree/${workspaceDir}`;

  const base = url.toString();
  return finalCellId ? `${base}#cell-id=${finalCellId}` : base;
}
